import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import ConstituencyModel from "../../models/masters/constituency-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Constituency/GetAllConstituency";// //{/api/Constituency/GetAllConstituency}`)  //// "https://localhost:7054/api/Constituency/GetAllConstituency";
export const useGetConstituency = createQuery<
ConstituencyModel[],
  null,
  AxiosError
>({
  queryKey: ["keyConstituencypage"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
